import { useMutation, useQuery, useQueryClient } from "react-query";
import useUserContext from "../contexts/UserContext";
import useApiHelper from "../services/useApiHelper";

export default function useProperties() {
  const staleTime = 1000 * 60; //60 seconds
  const queryClient = useQueryClient();
  const {
    user: { agency },
  } = useUserContext();
  const { get, post, put, del } = useApiHelper();

  const properties = useQuery(["properties", agency.id], () => get(`/Property/${agency.id}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  const updateNotes = useMutation((mutateData) => put(`/Property/${agency.id}/${mutateData.propertyId}`, mutateData.newNote), {
    onSuccess: (updatedProperty) => {
      queryClient.setQueryData(["properties", agency.id], (currrentProperties) =>
        currrentProperties.map((property) =>
          property.id === updatedProperty.data.id ? updatedProperty.data : property
        )
      );
    },
  });

  const removeNote = useMutation((ids) => put(`/Property/${agency.id}/${ids.propertyId}/${ids.noteId}`), {
    onSuccess: (_, ids) => {
      queryClient.setQueryData(["properties", agency.id], (currentProperties) =>
        currentProperties.map((property) => {
          if (property.notes.some(c => c.id === ids.noteId)) {
            property.notes = property.notes.filter(note => note.id !== ids.noteId);
            return property;
          } else {
            return property;
          }
        })
      );
    },
  });

//   const add = useMutation((review) => post(`/Review/${agency.id}`, review), {
//     onSuccess: (addedReview) => {
//       console.log(addedReview);
//       queryClient.setQueryData(["reviews", agency.id], (currentReviews) => [
//         addedReview.data,
//         ...currentReviews,
//       ]);
//     },
//   });

//   const update = useMutation(
//     (review) => put(`/Review/${agency.id}/${review.id}`, review),
//     {
//       onSuccess: (updatedReview) => {
//         queryClient.setQueryData(["reviews", agency.id], (currentReviews) =>
//           currentReviews.map((site) =>
//             site.id === updatedReview.id ? updatedReview : site
//           )
//         );
//       },
//     }
//   );

//   const remove = useMutation(
//     (reviewId) => del(`/Review/${agency.id}/${reviewId}`),
//     {
//       onSuccess: (_, reviewId) => {
//         queryClient.setQueryData(["reviews", agency.id], (currentReviews) =>
//           currentReviews.filter((site) => site.id !== reviewId)
//         );
//       },
//     }
//   );

  return {
    properties,
    updateNotes,
    removeNote,
    // add,
    // update,
    // remove,
  };
}
